import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

export const WrapperTextArea = styled.div`
  flex: 1;
  position: relative;
`;

export const CharactersInfo = styled.div`
  position: absolute;
  bottom: 30px;
  right: 10px;
  color: ${commonPalette.textSecondary};
`;

export const TextArea = styled.textarea`
  color: ${commonPalette.textPrimary};
  margin-bottom: 20px;
  height: 150px;
  resize: none;
  font-family: Lato;
  font-size: 16px;
  padding: 10px 15px;
  border: 1px solid ${commonPalette.strokeDefault};
  border-radius: 3px;
  outline: none;
  width: 100%;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${commonPalette.textSecondary};
  }
  :-ms-input-placeholder {
    color: ${commonPalette.textSecondary};
  }

  &:focus {
    border: 1px solid ${commonPalette.sgGreen};
    -webkit-box-shadow: 0px 0px 3px 1px ${commonPalette.sgGreen};
    box-shadow: 0px 0px 3px 1px ${commonPalette.sgGreen};
  }
`;
